import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "surveyContent" }
const _hoisted_2 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_3 = { class: "wp1200 survey" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_survey absolute" }, null, -1)
const _hoisted_5 = { class: "surveyCard" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "notification" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_check-round icon" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("ul", { class: "none" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.surveys.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t("global.no_data")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surveys, (survey, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "boxMessage",
          key: index
        }, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h4", null, _toDisplayString(survey.long_project_name), 1),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("survey.completed")), 1)
              ]),
              _hoisted_9
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}